/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-27",
    versionChannel: "nightly",
    buildDate: "2025-05-27T00:06:53.376Z",
    commitHash: "154f54eb11f4dfaf03f69c4cc614a0a36f00b9e7",
};
